import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import HomePage from "@system/config/home-page";
import System from "src/helper/system";
import useReduxState from "src/hooks/useReduxState";
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import { useHomePageContentStore } from "../../hooks/HomePageContent";
import Product from "@system/config/product";
import { HomePageContent } from './HomePageContent';
import NewProductInformationTabContent from './HomePageTabs/NewProductInformationTabContent';
import ProductDocumentsTabContent from './HomePageTabs/ProductDocumentsTabContent';
import ProductListingTabContent from './HomePageTabs/ProductListingTabContent';
import ProductTabContent from './HomePageTabs/ProductTabContent';
import Constants from "src/helper/Constants";
import ShowAlert from "src/component/Global/ShowAlert";
import Cookies from "js-cookie";

const default_component = { param_value: 'PLT', element: HomePageContent }
const param_key_HomeTabList = '__c_HomeTabList';

const HomePageTabsListing = (props) => {
  const c = System.getParams();
  const [__check] = useAxiosIndicatorCheck();
  const { homePageAllTabs, pathNameAmericasCookie } = Constants
  const [{ allTabsCount }, { get_all_tab_count }] = useHomePageContentStore();
  const homeTabType = System.getParams().__c_HomeTabList;
  const [selectedTab, setSelectedTab] = useReduxState(homePageAllTabs.PRODUCT.abbr, "searchParams");
  const [searchParams] = useSearchParams();
  const [searchContentEventDetected, setSearchContentEventDetected] = useState(false);
  const [tempTab, setTempTab] = useState();
  const [listingAPICallLoader] = useReduxState(false, 'product_listing_listingAPICallLoader');
  const [selectedFilterList, setSelectedFilterList] = useReduxState([], 'selectedFilterList');
  const [filterFacets, setFilterFacets] = useReduxState([], 'setFilterFacets');
  let defaultTabList = {
    PLT: {
      name: homePageAllTabs.PRODUCT.tabHeader,
      param_value: homePageAllTabs.PRODUCT.abbr,
      count: 0
    },
    NPIT: {
      name: homePageAllTabs.NPI.tabHeader,
      param_value: homePageAllTabs.NPI.abbr,
      count: 0
    },

    CNT: {
      name: homePageAllTabs.CONTENT.tabHeader,
      param_value: homePageAllTabs.CONTENT.abbr,
      count: 0
    },
    DCT: {
      name: homePageAllTabs.DOCUMENT.tabHeader,
      param_value: homePageAllTabs.DOCUMENT.abbr,
      count: 0
    }
  };

  const [homeTabList, setHomeTabList] = useState(defaultTabList)

  const getActiveClass = (singleElement) => {
    if (selectedTab === singleElement.param_value) {
      return "active";
    }
    return "";
  };

  const getTabLink = (singleElement) => {
    return HomePage.getHomeTabsListRouteURL({
      ...c,
      [param_key_HomeTabList]: singleElement.param_value,
    });
  };

  const switchTab = async (url, chain_single) => {
    setSelectedFilterList([])
    setFilterFacets([])
    history.pushState("", "", url);
    setSelectedTab(chain_single.param_value);
    Cookies.set(pathNameAmericasCookie, window.location.href);
  };

  useEffect(() => {
    async function fetchHere() {
      let bom_plp_mode_detected;
      if (props.isBomPLP) {
        bom_plp_mode_detected = true;
      }
      if (bom_plp_mode_detected === false && searchParams.get(param_key_HomeTabList) !== default_component.param_value) {
        if (c.search === undefined) {
          window.location.href = getTabLink(default_component);
        }
        if (c.search && c.search.length < 2) {
          window.location.href = getTabLink(default_component);
        }
      }
      const _defaultTab = homeTabType;

      let _homeTabType = _defaultTab ? _defaultTab : homePageAllTabs.PRODUCT.abbr;

      setSelectedTab(_homeTabType);

      if (bom_plp_mode_detected !== true && c.search && c.search.length > 1) {
        setSearchContentEventDetected(true);
      }
      if (c.search) {
        const params = { searchParam: c.search, currentTab: _homeTabType };
        await get_all_tab_count(params);
        if (_defaultTab) {
          let v = {}
          v.param_value = _defaultTab
          await switchTab(getTabLink(v), v);
          setTempTab(_defaultTab)
        } else { setTempTab("") }
      }
    }

    fetchHere();
  }, []);

  useEffect(() => {
    async function fetchHere() {
      setSelectedTab(homeTabType ? homeTabType : homePageAllTabs.PRODUCT.abbr);
    }

    fetchHere();
  }, [homeTabType]);

  useEffect(() => {
    let temData = { ...homeTabList }
    temData.PLT.count = allTabsCount.productListingCount || 0
    temData.NPIT.count = allTabsCount.npiCount || 0
    temData.CNT.count = allTabsCount.allContentCount || 0
    temData.DCT.count = allTabsCount.docCount || 0
    setHomeTabList(temData)
  }, [allTabsCount])

  useEffect(() => {
    async function fetchHere() {
      if (tempTab !== undefined && listingAPICallLoader) {

        let v = {};
        const lstCnt = allTabsCount.productListingCount
        if (lstCnt && lstCnt > 0) {
          v.param_value = homePageAllTabs.PRODUCT.abbr
        } else if (allTabsCount.npiCount > 0) {
          v.param_value = homePageAllTabs.NPI.abbr
        } else if (allTabsCount.allContentCount > 0) {
          v.param_value = homePageAllTabs.CONTENT.abbr
        } else if (allTabsCount.docCount > 0) {
          v.param_value = homePageAllTabs.DOCUMENT.abbr
        } else {

          delete c.search;
          history.pushState(null, null, '?' + $.param(c));
          window.location.href = Product.getProductListingNotFoundPageRouteURL() + '?' + $.param(c);
        }
        if (v.param_value) {
          await switchTab(getTabLink(v), v);
          setTempTab(v.param_value);
        }
      }
    }
    fetchHere();
  }, [listingAPICallLoader, tempTab])

  useEffect(() => {
    if (document.getElementsByClassName('snippet') && document.getElementsByClassName('snippet').length > 0) {
      document.getElementsByClassName('snippet')[0].style.display = 'none';
    }
  }, [])
  return (
    <>
      {!props.isBomPLP &&
        searchContentEventDetected && (
          <div className="container">

            <div className="mt-2">
              <ShowAlert onlyShowMessage={['createBom', 'addPartToBom']} />
            </div>


            <ul className="bs5 nav nav-tabs">
              {Object.entries(homeTabList).map((v) => (
                <React.Fragment key={v[1].name}>
                  <li className="bs5 nav-item" key={v[1].name}>
                    <a className={"nav-link " + getActiveClass(v[1])}
                      href={void 0}
                      onClick={async () => {
                        // System.clearAllAlert();
                        await switchTab(HomePage.makeHomeTabsListRouteURL(v[1].param_value) + "&search=" + c.search, v[1]);
                      }}
                    >
                      <span>
                        {v[1].name}{" "}{'(' + (v[1].count > 100000 ? 100000 : v[1].count) + ')'}
                      </span>
                    </a>
                  </li>
                </React.Fragment>
              ))}
            </ul>
          </div>
        )}
      <div className="search-page-tab mobile-tab">
        <div id={selectedTab} className="active" >
          {selectedTab === homePageAllTabs.PRODUCT.abbr && <ProductListingTabContent {...props} />}
          {selectedTab === homePageAllTabs.NPI.abbr && <NewProductInformationTabContent {...props} />}
          {selectedTab === homePageAllTabs.CONTENT.abbr && <ProductTabContent {...props} />}
          {selectedTab === homePageAllTabs.DOCUMENT.abbr && <ProductDocumentsTabContent {...props} />}
        </div>
      </div>
    </>
  );
};

export default HomePageTabsListing;